import React, { useEffect } from "react";
import { useModal } from "contexts/modalContext/modalContext.js";

const VerificationContainer = ({ children }) => {
  const { getIsAboutToClose } = useModal();

  return getIsAboutToClose() ? null : (
    <div className="modal-content">{children}</div>
  );
};

export default VerificationContainer;
